import React, { useEffect, useState } from 'react'
import * as S from './style'
import { arrowLeft, arrowRight } from '@assets/icons'
import Svg from '@components/svg'

interface PaginationProps {
  isShown?: boolean
  totalPages?: number
  itemsPerpage?: number
  totalItems?: number
  currentPage?: number
  setPage?: (page: number) => void
  maxVisiblePages?: number
}

const Pagination: React.FC<PaginationProps> = ({
  isShown,
  currentPage = 1,
  setPage = () => {},
  totalPages = 1,
  totalItems = 0,
  itemsPerpage = 10,
  maxVisiblePages = 5,
}) => {
  const handlePagination = (page: number) => {
    setPage(page)
  }

  const handlePrev = () => {
    if (currentPage > 1) {
      setPage(currentPage - 1)
    }
  }

  const handleNext = () => {
    if (currentPage < totalPages) {
      setPage(currentPage + 1)
    }
  }

  const getVisiblePages = () => {
    const pages = []
    let startPage = 1
    let endPage = totalPages

    if (totalPages > maxVisiblePages) {
      const half = Math.floor(maxVisiblePages / 2)
      startPage = Math.max(currentPage - half, 1)
      endPage = startPage + maxVisiblePages - 1

      if (endPage > totalPages) {
        endPage = totalPages
        startPage = endPage - maxVisiblePages + 1
      }
    }

    if (startPage > 1) {
      pages.push(1)
      if (startPage > 2) pages.push('...')
    }

    for (let i = startPage; i <= endPage; i++) {
      if (i >= 1 && i <= totalPages) pages.push(i)
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) pages.push('...')
      pages.push(totalPages)
    }

    return pages
  }

  const startItem = (currentPage - 1) * itemsPerpage + 1
  const endItem = Math.min(currentPage * itemsPerpage, totalItems)

  return (
    <S.StylePaginationWrapper hide={isShown}>
      <S.StyleCountWrapper>
        Showing {startItem}-{endItem} of {totalItems}
      </S.StyleCountWrapper>

      <S.StylePaginationButtonWrapper>
        <S.StylePaginationButton onClick={handlePrev}>
          <Svg src={arrowLeft} />
        </S.StylePaginationButton>

        {getVisiblePages().map((page, index) =>
          page === '...' ? (
            <S.StylePaginationButton key={index}>
              {page}
            </S.StylePaginationButton>
          ) : (
            <S.StylePaginationButton
              key={index}
              $active={currentPage === page}
              onClick={() => handlePagination(page as number)}
            >
              {page}
            </S.StylePaginationButton>
          ),
        )}

        <S.StylePaginationButton onClick={handleNext}>
          <Svg src={arrowRight} />
        </S.StylePaginationButton>
      </S.StylePaginationButtonWrapper>
    </S.StylePaginationWrapper>
  )
}

export default Pagination
